export const articlesQuery = gql`
  query getEntries(
    $sort: String = "date desc",
    $site: String!,
    $page: Int! = 0,
    $limit: Int! = 999,
    $filter: JsonArgument,
    $collection: [String],
  ) {
    entries(
      sort: [$sort],
      site: $site,
      page: $page,
      limit: $limit,
      filter: $filter,
      collection: $collection,
    ) {
      to
      from
      total
      last_page
      current_page
      has_more_pages

      data {
        ... on Entry_Articles_Article {
          id
          url
          title
          image {
            id
            sm: responsiveAsset(width: 420, height: 270, format: "webp") { url, alt, width, height }
            md: responsiveAsset(width: 640, height: 410, format: "webp") { url, alt, width, height }
            lg: responsiveAsset(width: 960, height: 615, format: "webp") { url, alt, width, height }
          }
          article_categories {
            id
            slug
            title
          }
        }
      }
    }
  }
`;
